import { PATH } from './const';
import { ApiFindOneOptions, useApiFindOne } from '../../../../../lib/HttpService';
import { StubbornData } from '../../../../../application/business';

export const useEditionAssetFind = (options: ApiFindOneOptions = {}) => useApiFindOne<StubbornData[]>(PATH, options);
